import {useEffect, useState, useRef} from 'react';
import { Row, Col, Container } from 'reactstrap';
import ParentsSection from './ParentsSection';
import WagesSalaries from './WagesSalaries';
import TimeParents from './TimeParents';
import TaxEstimator from './TaxEstimator';
import Estimator from './Estimator';
import * as label from '../constants';
import { useSelector } from 'react-redux'


const MainForm = () => {

  const [ value, setValue ] = useState(0); 
  const [ isFormOpen, setIsFormOpen ] = useState(false); 
  const [ rowWidth, setRowWidth ] = useState(0); 
  const [ headerHeight, setHeaderHeight] = useState(0);
  const [ containerHeight, setContainerHeight ] = useState(0);
  const [ topMonitor, setTopMonitor ] = useState(8);
  const [ endContainer, setEndContainer ] = useState(0);

  const [ monitorClassName, setMonitorClassName ] = useState('');

  const [headerWidth, setHeaderWidth] = useState(0);
  const refHeader = useRef(null);
  const refContainer = useRef(null);
  const isOpen = useSelector((state) => state.ui.isFormOpen);


  useEffect(() => {
    const handleScroll = () => {
      setValue( window.scrollY);
    };

    const handleResize = () => {
      setHeaderHeight(refHeader.current.clientHeight);
      setContainerHeight(refContainer.current.clientHeight);
      handleRowWidth();
    }

    handleRowWidth();
    setHeaderHeight(refHeader.current.clientHeight);
    setHeaderWidth(refHeader.current.clientWidth);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
    
  }, []);


  useEffect(() => {
    getMonitorClassName(); 
  }, [value,headerHeight,containerHeight]);

  useEffect(() => {

    const isOpenTabs = Object.values(isOpen).reduce((acc, cValue) => {
      return acc || cValue;
    }, false);

    setIsFormOpen(isOpenTabs);
  }, [isOpen.PARENTS_AND_CHILDREN,isOpen.WAGES_AND_SALARIES,isOpen.TIME_WITH_PARENTS,isOpen.TAX_ESTIMATOR]);


  const handleRowWidth = () => {
    setRowWidth(document.getElementById("row-form").clientWidth - 20 - 405);
  }


  const renderForm = () =>{
    return (
      <>
        <ParentsSection/>
        <WagesSalaries/>
        <TimeParents/>
        <TaxEstimator/>
      </>
    )
  }

  const getMarginTopForm  = () =>{
    const isMobile = document.getElementById('root').clientWidth < 992;
    if (monitorClassName==='on-bottom' && isMobile) return 8;
    if (monitorClassName==='on-scroll' && isMobile) return (headerHeight + 10 );
    return 0;
  }

  const getMonitorClassName = () => {

    const offsetTop = document.getElementById('root').offsetTop;
    const isMobile = document.getElementById('root').clientWidth < 992;
    const containerH = refContainer?.current?.clientHeight;
    const scrollY = value;

    const diffStart = isMobile ? 62 : 40;
    const diffEnd = isMobile ? - 206 + (monitorClassName==='on-bottom' ? - 64 : 0) : - 276 - 30;
    const monitorStart = offsetTop + headerHeight + diffStart - 105;
    const monitorEnd = offsetTop + containerH + diffEnd - 105;
    if (monitorClassName!=='on-bottom'){
      setEndContainer(monitorEnd);
    }

    if (scrollY <= monitorStart && monitorClassName!=='') {
      setMonitorClassName('');
      return;
    }

    if (scrollY > monitorStart && scrollY < endContainer  && monitorClassName!=='on-scroll'){
      setMonitorClassName('on-scroll');
      setTopMonitor(113);
      return;
    }

    if (scrollY >= endContainer  && monitorClassName!=='on-bottom')
    {
      const top = isMobile ? 0 : refContainer?.current?.clientHeight-refHeader?.current?.clientHeight - 270 - 56;
      setTopMonitor(top);
      setMonitorClassName('on-bottom');
      return;
    }

  }




  return (
    <div ref={refContainer}>
      <div className='header' ref={refHeader}>
        <h1 className='blue-text'>{label.header.TITLE}</h1>
        <p className="small-body">{label.header.DESCRIPTION}</p>
      </div>

    <Container fluid="lg"
      style={{maxWidth: 1205}}
    >
      <Row id="row-form">
        <Col
          style={{
            marginTop: getMarginTopForm(),
            maxWidth: document.getElementById('root').clientWidth < 992 ? '100% !important' : Math.min(rowWidth,780)
          }}
          lg={{size: 'auto', order: 1}} xs={{size:12, order:2}}
          className='md-max-width'
        >
          {renderForm()}
        </Col>
        <Col
          className={`monitor-main-container ${monitorClassName}`}
          lg={{size: 'auto', order: 2}} xs={{size:12, order:1}}
          
          >
          <Estimator
            value={value}
            extraClassName={monitorClassName}
            style={{
              top:topMonitor,
              width: document.getElementById('root').clientWidth < 992 &&  '100% !important'
            }}
          />
        </Col>
      </Row>
    </Container>

    </div>

  )
}

export default MainForm;

